import { allFetch } from "../Domain";

/**
 * @description 審核
 */
export const Audit = (() => {
    /**
     * @description 預約查詢
     * audit_json: List<AuditProcedureOBJ>
     * @param {*} type 種類
     * @param {*} id 流水號
     * @param {*} audit_json 審核進度json
     * @param {*} status 審核流程狀態
     * @param {*} note 備註
     * @returns 
     */
    const AuditProcedureCreate = async function (obj = {
        type: '',
        id: '',
        audit_json: [],
        status: '',
        note: ''
    }) {
        return await allFetch('Audit/AuditProcedureCreate', obj);
    }

    /**
     * 審核流程修改
     * audit_json: List<AuditProcedureOBJ>
     * @param {*} type 種類
     * @param {*} id 流水號
     * @param {*} audit_json 審核進度json
     * @param {*} status 審核流程狀態
     * @param {*} note 備註
     * @returns 
     */
    const AuditProcedureUpdate = async function (obj = {
        type: '',
        id: '',
        audit_json: [],
        status: '',
        note: ''
    }) {
        return await allFetch('Audit/AuditProcedureUpdate', obj);
    }

    /**
     * 審核流程查詢
     * @param {*} type 種類
     * @param {*} id 流水號
     * @param {*} status 審核流程狀態
     * @param {*} page 頁碼
     * @param {*} num_per_page 一頁幾筆
     * @returns 
     */
    const AuditProcedureSearch = async function (obj = {
        type: '',
        id: '',
        status: '',
        page: 0,
        num_per_page: 10
    }) {
        return await allFetch('Audit/AuditProcedureSearch', obj);
    }

    /**
     * 進審核頁面呼叫，決定審核按鈕要不要出現
     * @param {*} id 流水號
     * @returns 
     */
    const AuditProcedureButtomCheck = async function (obj = {
        id: ""
    }) {
        return await allFetch('Audit/AuditProcedureButtomCheck', obj);
    }

    return {
        AuditProcedureCreate,
        AuditProcedureUpdate,
        AuditProcedureSearch,
        AuditProcedureButtomCheck
    }
})();